(function () {
  const config = document.getElementById('PptCustomilyConfig');
  if (!config) return;

  const title = config.dataset.title;
  const guideText = config.dataset.guideText;
  const guideUrl = config.dataset.guideUrl;
  if (!title && !guideText) return;

  function buildHeader() {
    const header = document.createElement('div');
    header.className = 'ppt-cl-header';

    if (title) {
      const heading = document.createElement('p');
      heading.className = 'ppt-cl-header__title';
      heading.textContent = title;
      header.appendChild(heading);
    }

    if (guideText && guideUrl) {
      const link = document.createElement('a');
      link.className = 'ppt-cl-header__guide';
      link.href = guideUrl;
      link.textContent = guideText;
      header.appendChild(link);
    }

    return header;
  }

  function decorate() {
    const widget = document.getElementById('cl_optionsapp');
    if (!widget || !widget.parentNode) return false;

    const previous = widget.previousElementSibling;
    if (previous && previous.classList.contains('ppt-cl-header')) return true;

    widget.parentNode.insertBefore(buildHeader(), widget);
    return true;
  }

  if (decorate()) return;

  const observer = new MutationObserver(() => {
    if (decorate()) observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(() => observer.disconnect(), 20000);
})();
